export enum ContentCardVariant {
  Contained = 'contained',
  Outlined = 'outlined',
  Paper = 'paper',
  Dashed = 'dashed',
}

export enum ContentCardPadding {
  None = 'none',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export type HeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
